/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Defect_Shelf_Err_Invalid_ItemInputs */

const vi_defect_shelf_err_invalid_item = /** @type {(inputs: Defect_Shelf_Err_Invalid_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng hàng lỗi không hợp lệ so với số đã xuất của đơn.`)
};

/**

* @param {Defect_Shelf_Err_Invalid_ItemInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const defect_shelf_err_invalid_item = /** @type {((inputs?: Defect_Shelf_Err_Invalid_ItemInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Defect_Shelf_Err_Invalid_ItemInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_defect_shelf_err_invalid_item(inputs)
});